import { render, staticRenderFns } from "./ListaDePostagens.vue?vue&type=template&id=6414fe76&scoped=true&"
import script from "./ListaDePostagens.vue?vue&type=script&lang=js&"
export * from "./ListaDePostagens.vue?vue&type=script&lang=js&"
import style0 from "./ListaDePostagens.vue?vue&type=style&index=0&id=6414fe76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6414fe76",
  null
  
)

export default component.exports